import { createApp, h } from 'vue';
import HubApp from '~/plugins/hub_app';
import PopoverAvatar from '~/components/PopoverAvatar.vue';

document.addEventListener('readystatechange', () => {
  window.initPopoverAvatar();
});

window.initPopoverAvatar = () => {
  $('span[data-vue="popover-avatar"]').each((_, el) => {
    const { vue: _mountMarker, ...props } = el.dataset;
    const html = el.innerHTML;
    const app = createApp({
      name: `PopoverAvatar-${el.dataset.userId}`,
      render: () => h(PopoverAvatar, { ...props, html }),
    });

    app.use(HubApp); // registers the global v-tooltip directive
    // Vue 3 mounts inside the span instead of replacing it (Vue 2 behavior);
    // the inline wrapper squashes the avatar, so take it out of the layout.
    el.style.display = 'contents';
    app.mount(el);
  });
};
